import React from 'react';
// Import the logo as a module for reliable bundling
import billyLogo from '../assets/billy-wingco-logo.png';

// Inline SVG components to avoid parsing issues
export const PintIcon = ({ className = "h-12 w-12" }) => (
  <svg className={className} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="neonGlowPint" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
        <feMerge> 
          <feMergeNode in="coloredBlur"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    
    <path d="M12 8 L28 8 L26 34 L14 34 Z" 
          fill="none" 
          stroke="#1FB6FF" 
          strokeWidth="2" 
          filter="url(#neonGlowPint)"/>
    
    <line x1="10" y1="8" x2="30" y2="8" 
          stroke="#1FB6FF" 
          strokeWidth="3" 
          strokeLinecap="round" 
          filter="url(#neonGlowPint)"/>
    
    <path d="M14 12 Q16 10, 18 12 Q20 10, 22 12 Q24 10, 26 12" 
          fill="none" 
          stroke="#1FB6FF" 
          strokeWidth="1" 
          opacity="0.8"/>
    
    <line x1="15" y1="18" x2="25" y2="18" 
          stroke="#1FB6FF" 
          strokeWidth="1" 
          opacity="0.6"/>
  </svg>
);

export const CanIcon = ({ className = "h-12 w-12" }) => (
  <svg className={className} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="neonGlowCan" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
        <feMerge> 
          <feMergeNode in="coloredBlur"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    
    <rect x="14" y="8" width="12" height="26" rx="2" 
          fill="none" 
          stroke="#1FB6FF" 
          strokeWidth="2" 
          filter="url(#neonGlowCan)"/>
    
    <ellipse cx="20" cy="8" rx="6" ry="2" 
             fill="none" 
             stroke="#1FB6FF" 
             strokeWidth="2" 
             filter="url(#neonGlowCan)"/>
    
    <ellipse cx="20" cy="8" rx="2" ry="1" 
             fill="none" 
             stroke="#1FB6FF" 
             strokeWidth="1"/>
    
    <line x1="16" y1="14" x2="24" y2="14" 
          stroke="#1FB6FF" 
          strokeWidth="1" 
          opacity="0.7"/>
    <line x1="16" y1="28" x2="24" y2="28" 
          stroke="#1FB6FF" 
          strokeWidth="1" 
          opacity="0.7"/>
  </svg>
);

export const BottleIcon = ({ className = "h-12 w-12" }) => (
  <svg className={className} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="neonGlowBottle" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
        <feMerge> 
          <feMergeNode in="coloredBlur"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    
    <path d="M16 6 L16 10 L14 12 L14 32 L26 32 L26 12 L24 10 L24 6 Z" 
          fill="none" 
          stroke="#1FB6FF" 
          strokeWidth="2" 
          filter="url(#neonGlowBottle)"/>
    
    <rect x="15" y="4" width="10" height="4" rx="1"
          fill="none" 
          stroke="#1FB6FF" 
          strokeWidth="2" 
          filter="url(#neonGlowBottle)"/>
    
    <rect x="16" y="16" width="8" height="8" rx="1"
          fill="none" 
          stroke="#1FB6FF" 
          strokeWidth="1" 
          opacity="0.7"/>
  </svg>
);

export const ShakerIcon = ({ className = "h-12 w-12" }) => (
  <svg className={className} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="neonGlowShaker" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
        <feMerge> 
          <feMergeNode in="coloredBlur"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    
    <path d="M16 6 L24 6 L22 12 L22 30 L18 30 Z" 
          fill="none" 
          stroke="#FF2E2E" 
          strokeWidth="2" 
          filter="url(#neonGlowShaker)"/>
    
    <ellipse cx="20" cy="6" rx="4" ry="2" 
             fill="none" 
             stroke="#FF2E2E" 
             strokeWidth="2" 
             filter="url(#neonGlowShaker)"/>
    
    <line x1="19" y1="15" x2="21" y2="15" 
          stroke="#FF2E2E" 
          strokeWidth="1" 
          opacity="0.7"/>
    <line x1="19" y1="20" x2="21" y2="20" 
          stroke="#FF2E2E" 
          strokeWidth="1" 
          opacity="0.7"/>
    <line x1="19" y1="25" x2="21" y2="25" 
          stroke="#FF2E2E" 
          strokeWidth="1" 
          opacity="0.7"/>
  </svg>
);

export const LogoIcon = ({ className = "w-72 md:w-96", ...props }) => {
  return (
    <img
      src={billyLogo}
      alt="Billy's WingCo - Professional Logo"
      className={`${className} filter drop-shadow-lg hover:drop-shadow-xl transition-all duration-200`}
      style={{
        filter: 'drop-shadow(0 0 8px rgba(31, 182, 255, 0.3)) drop-shadow(0 0 16px rgba(255, 46, 46, 0.3))'
      }}
      {...props}
    />
  );
}; 